import { render, staticRenderFns } from "./GridCarousel.vue?vue&type=template&id=72bc1b0b"
import script from "./GridCarousel.vue?vue&type=script&lang=js"
export * from "./GridCarousel.vue?vue&type=script&lang=js"
import style0 from "./GridCarousel.vue?vue&type=style&index=0&id=72bc1b0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports